import React from 'react'

import BodyModifications from './BodyModifications'
import EngineModifications from './EngineModifications'
import { vehicleParts } from '../viewVehicle.description'

const ModificationView = ({ activeMenu }) => {
  const getComponent = () => {
    switch (activeMenu) {
      case vehicleParts.engine:
        return <EngineModifications />
      case vehicleParts.body:
        return <BodyModifications />

      default:
        return <></>
    }
  }
  return <>{getComponent()}</>
}

export default ModificationView
